import { createSelector } from 'reselect';
import reduce from 'ramda/es/reduce';
import prop from 'ramda/es/prop';


const selectItemsNumber = createSelector(
  [
    state => state.shop.cart.cartItems,
  ],
  reduce((acc, val) => (acc + prop('quantity', val)), 0),
);

export default selectItemsNumber;
